export const DEFAULT_START_BASEMAP_STYLE_SESSION_URL =
  "https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/sessions/start";

export const DEFAULT_SAFETY_MARGIN = 5 * 60; // Default to 5 minutes in seconds

export const DEFAULT_CHECK_EXPIRATION_INTERVAL = 10; // Default to 10 seconds

export const DEFAULT_DURATION = 12 * 60 * 60; // Default to 12 hours in seconds
